<script setup lang="ts">
  import { computed } from 'vue'

  interface Props {
    color?: string
    height?: number
  }

  const props = withDefaults(defineProps<Props>(), {
    color: '#1C9DD4',
    height: 500,
  })
  const computedHeight = computed(() => {
    return 'height: ' + props.height + 'px;'
  })
</script>
<template>
  <div
    id="loading-spinner-wrap"
    class="w-full flex items-center justify-center"
    :style="computedHeight"
  >
    <svg
      id="loading-spinner"
      width="50"
      height="50"
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M250.121 334.257C203.818 334.257 166.223 296.634 166.223 250.297C166.223 203.96 203.818 166.337 250.121 166.337C296.423 166.337 334.019 203.96 334.019 250.297C334.019 296.634 296.423 334.257 250.121 334.257ZM250.121 191.683C217.867 191.683 191.352 218.02 191.352 250.495C191.352 282.97 217.669 309.307 250.121 309.307C282.572 309.307 308.889 282.97 308.889 250.495C308.889 218.02 282.374 191.683 250.121 191.683Z"
        :fill="color"
      />
      <path
        d="M250.121 417.624C158.11 417.624 83.1161 342.574 83.1161 250.495C83.1161 158.416 158.11 83.3662 250.121 83.3662C342.132 83.3662 417.125 158.416 417.125 250.495C417.125 342.574 342.132 417.624 250.121 417.624ZM250.121 108.515C171.961 108.515 108.246 172.277 108.246 250.495C108.246 328.713 171.961 392.475 250.121 392.475C328.28 392.475 391.996 328.713 391.996 250.495C391.996 172.079 328.28 108.515 250.121 108.515Z"
        :fill="color"
      />
      <path
        d="M499.44 229.901C494.889 174.059 471.936 123.564 436.913 84.1584C428.998 75.2475 420.291 66.7327 411.189 59.0099C372.01 25.9406 322.542 4.55445 268.127 0.792075C262.191 0.396035 256.255 0 250.121 0C243.987 0 238.05 0.198015 232.114 0.792075C176.71 4.75247 126.252 26.9307 86.4798 61.3861C79.95 67.1287 73.6181 73.0693 67.6819 79.4059C63.9223 83.3663 63.9223 89.703 67.8798 93.6634L71.2436 97.0297C75.3989 101.188 81.9287 100.99 85.8862 96.8317C91.6245 90.6931 97.7586 84.7525 104.288 79.2079C139.312 49.3069 183.437 29.901 231.916 26.1386C237.853 25.7426 243.789 25.3465 249.923 25.3465C256.057 25.3465 261.993 25.7426 267.929 26.1386C315.221 29.901 358.555 48.3168 392.985 77.0297C402.285 84.7525 410.793 93.0693 418.708 102.178C449.379 137.03 469.364 181.386 473.717 230.099C474.311 236.832 474.706 243.564 474.706 250.495C474.706 255.842 474.508 260.99 474.113 266.139C470.749 315.644 451.159 360.792 420.885 396.436L438.693 414.257C473.519 374.059 495.879 322.574 499.242 266.139C499.638 260.99 499.836 255.842 499.836 250.495C500.232 243.564 499.836 236.634 499.44 229.901Z"
        :fill="color"
      />
      <path
        d="M241.414 481.188L241.018 493.267C240.82 497.03 243.788 500 247.548 500H250.12H253.088C256.848 500 259.618 497.03 259.618 493.267L259.222 481.188C259.025 477.624 256.254 474.852 252.693 474.852H248.142C244.382 474.852 241.414 477.624 241.414 481.188Z"
        :fill="color"
      />
      <path
        d="M209.359 496.634C211.14 497.03 212.921 497.228 214.899 497.426C218.659 498.02 222.023 495.446 222.419 491.683L223.804 479.604C224.199 476.04 221.825 472.871 218.263 472.277L213.712 471.485C210.15 470.891 206.984 473.267 206.193 476.832L203.818 488.713C203.225 492.673 205.599 496.04 209.359 496.634Z"
        :fill="color"
      />
      <path
        d="M172.159 487.525C173.94 488.119 175.721 488.713 177.501 489.109C181.063 490.099 184.823 488.119 185.812 484.555L188.978 472.871C189.967 469.505 187.989 465.941 184.625 464.951L180.272 463.564C176.908 462.574 173.346 464.356 172.159 467.525L168.004 478.812C166.618 482.574 168.597 486.535 172.159 487.525Z"
        :fill="color"
      />
      <path
        d="M136.74 472.871C138.323 473.663 140.103 474.456 141.686 475.248C145.05 476.832 149.008 475.446 150.591 472.079L155.537 460.99C156.923 457.822 155.537 454.06 152.371 452.475L148.216 450.495C145.05 448.911 141.291 450.099 139.51 453.267L133.771 463.961C132.188 467.129 133.376 471.287 136.74 472.871Z"
        :fill="color"
      />
      <path
        d="M104.09 452.871C105.673 453.861 107.059 455.05 108.642 456.04C111.808 458.218 115.963 457.426 117.942 454.257L124.471 444.159C126.45 441.188 125.659 437.228 122.691 435.248L118.931 432.673C115.963 430.693 112.005 431.287 110.027 434.059L102.705 443.564C100.331 446.535 100.924 450.693 104.09 452.871Z"
        :fill="color"
      />
      <path
        d="M83.5116 410.495L74.8052 418.812C72.035 421.386 72.2328 425.743 74.8052 428.317C76.1903 429.703 77.3775 430.891 78.7626 432.079C81.5328 434.653 85.6882 434.455 88.2605 431.683L96.3733 422.574C98.7478 420 98.5499 415.842 95.9776 413.465L92.6137 410.297C90.0414 407.921 86.0839 407.921 83.5116 410.495Z"
        :fill="color"
      />
      <path
        d="M60.9543 383.168L51.0606 390.099C48.0925 392.277 47.301 396.436 49.6755 399.406C50.8627 400.792 51.8521 402.376 53.0393 403.762C55.4138 406.733 59.5691 407.129 62.3394 404.753L71.6394 397.03C74.4096 394.852 74.8053 390.693 72.6287 387.921L69.8585 384.357C67.6819 381.584 63.7245 380.99 60.9543 383.168Z"
        :fill="color"
      />
      <path
        d="M42.7498 352.673L31.8668 358.02C28.503 359.604 27.3158 363.762 29.0966 367.129C29.8881 368.713 30.8775 370.297 31.669 372.079C33.4498 375.445 37.6051 376.435 40.7711 374.653L51.0605 368.515C54.0286 366.732 55.2158 362.772 53.435 359.802L51.2584 355.841C49.6754 352.277 45.9158 351.089 42.7498 352.673Z"
        :fill="color"
      />
      <path
        d="M29.4922 319.802L18.0156 323.366C14.4539 324.554 12.6731 328.317 13.8603 331.881C14.4539 333.663 15.0475 335.445 15.6412 337.03C17.0263 340.594 20.7859 342.376 24.3476 340.792L35.6263 336.237C38.9902 334.851 40.5731 331.287 39.3859 327.921L37.8029 323.564C36.4178 320.594 32.8561 318.812 29.4922 319.802Z"
        :fill="color"
      />
      <path
        d="M21.3796 285.347L9.50724 287.129C5.74765 287.723 3.37317 291.089 3.96679 294.851C4.36254 296.634 4.56041 298.416 4.95616 300.198C5.74765 303.96 9.30936 306.139 12.8711 305.347L24.5456 302.574C27.9094 301.782 30.086 298.416 29.4924 294.851L28.7009 290.297C28.1073 287.129 24.7434 284.752 21.3796 285.347Z"
        :fill="color"
      />
      <path
        d="M18.6094 249.901H6.53916C2.77957 249.901 -0.188524 253.069 0.00934904 256.634C0.00934904 258.416 0.207219 260.396 0.207219 262.178C0.405092 265.94 3.57105 268.713 7.33064 268.515L19.4009 267.525C22.9626 267.327 25.5349 264.158 25.5349 260.792L25.3371 256.238C24.9413 252.673 22.1711 249.901 18.6094 249.901Z"
        :fill="color"
      />
      <path
        d="M21.1816 214.653L9.30925 212.871C5.54966 212.277 2.18582 214.851 1.79007 218.614C1.5922 220.396 1.39434 222.376 1.19646 224.158C0.800718 227.921 3.57093 231.089 7.33052 231.485L19.4008 232.475C22.9625 232.673 25.9306 230.099 26.3263 226.733L26.9199 222.178C27.1178 218.416 24.7433 215.247 21.1816 214.653Z"
        :fill="color"
      />
      <path
        d="M29.2945 180L17.8179 176.436C14.2562 175.247 10.4966 177.426 9.50723 180.99C8.91361 182.772 8.51784 184.554 8.12209 186.337C7.13273 189.901 9.30933 193.663 13.0689 194.455L24.7434 197.228C28.1073 198.02 31.669 196.04 32.4605 192.475L33.6477 188.119C34.4392 184.752 32.6583 181.188 29.2945 180Z"
        :fill="color"
      />
      <path
        d="M42.3541 147.129L31.4711 141.782C28.1072 140.198 24.1498 141.584 22.5668 144.95C21.7753 146.535 20.9838 148.317 20.3902 150.099C18.8072 153.465 20.3902 157.426 23.9519 158.812L35.2307 163.366C38.5945 164.752 42.1562 163.168 43.7392 160L45.7179 155.842C46.9052 152.475 45.5201 148.713 42.3541 147.129Z"
        :fill="color"
      />
      <path
        d="M60.5583 116.634L50.6647 109.703C47.4987 107.525 43.5412 108.317 41.3646 111.485C40.3753 113.069 39.3859 114.653 38.3966 116.238C36.4178 119.406 37.4072 123.564 40.5732 125.545L50.8625 131.683C53.8306 133.465 57.7881 132.475 59.7668 129.505L62.3392 125.545C64.12 122.574 63.3285 118.614 60.5583 116.634Z"
        :fill="color"
      />
      <path
        d="M413.366 383.762L451.555 421.98C454.523 424.951 453.534 430.297 449.576 431.881L387.247 456.832C382.3 458.812 377.551 454.06 379.332 449.109L403.472 385.941C405.055 381.782 410.398 380.594 413.366 383.762Z"
        :fill="color"
      />
      <path
        d="M250.121 265.544C260.175 265.544 268.325 257.388 268.325 247.327C268.325 237.265 260.175 229.109 250.121 229.109C240.067 229.109 231.916 237.265 231.916 247.327C231.916 257.388 240.067 265.544 250.121 265.544Z"
        :fill="color"
      />
    </svg>
  </div>
</template>

<style>
  #loading-spinner {
    animation: spin 0.96s infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(359deg);
    }
  }
</style>
